export const DEFAULT_LANG = 'es';

export const SEARCH_SELECT_CHARACTERS = 2;
